module.exports = __webpack_public_path__ + "static/img/Home05@2x.4558917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home05@2x.png
// module id = Mz7F
// module chunks = 1